/** Logo de ovelha do SheepCount (SVG inline, mesma paleta terracota do protótipo). */
export function SheepLogo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <circle cx="10" cy="10" r="6" fill="#fff" stroke="oklch(58% 0.14 45)" strokeWidth="2" />
      <circle cx="22" cy="10" r="6" fill="#fff" stroke="oklch(58% 0.14 45)" strokeWidth="2" />
      <circle cx="6" cy="16" r="5.5" fill="#fff" stroke="oklch(58% 0.14 45)" strokeWidth="2" />
      <circle cx="26" cy="16" r="5.5" fill="#fff" stroke="oklch(58% 0.14 45)" strokeWidth="2" />
      <circle cx="16" cy="13" r="8" fill="#fff" stroke="oklch(58% 0.14 45)" strokeWidth="2" />
      <ellipse
        cx="9"
        cy="20"
        rx="2.6"
        ry="3.8"
        fill="oklch(30% 0.03 60)"
        transform="rotate(-25 9 20)"
      />
      <ellipse
        cx="23"
        cy="20"
        rx="2.6"
        ry="3.8"
        fill="oklch(30% 0.03 60)"
        transform="rotate(25 23 20)"
      />
      <ellipse cx="16" cy="21" rx="7.2" ry="6.2" fill="oklch(30% 0.03 60)" />
      <circle cx="12.8" cy="20.5" r="1.15" fill="#fff" />
      <circle cx="19.2" cy="20.5" r="1.15" fill="#fff" />
      <circle cx="16" cy="24" r="1" fill="oklch(58% 0.14 45)" />
    </svg>
  );
}
